import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { fetchSearch } from 'actions/search';
import Search from 'components/Search';
import { resetSearchQuery } from 'actions/search';
import withKeepingLastFocus from 'components/HOCs/withKeepingLastFocus';
import {
  selectIsLoading,
  selectSearchInitialQuery,
  selectSearchResult,
} from 'reducers/search/selectors';

const mapState = createStructuredSelector({
  isLoading: selectIsLoading,
  results: selectSearchResult,
  initialQuery: selectSearchInitialQuery,
});

const mapDispatch = {
  fetchSearch,
  resetSearchQuery,
};

export default compose(
  connect(
    mapState,
    mapDispatch,
  ),
  withKeepingLastFocus,
)(Search);
